import React from "react";
import { useTranslation } from "react-i18next";
import "./styles/Services.css";
import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

function QtChartsGraphs() {
    const { t } = useTranslation();

    return (
        <div className="service-page">
            <SEO
                title={t('qtcharts.seo_title')}
                description={t('qtcharts.seo_desc')}
                keywords={t('qtcharts.seo_keywords')}
                url="/qt-charts-graphs"
                schemaType="service"
            />
            <TitleFragment title={t('qtcharts.page_title')} />

            <div className="service-container">
                <p className="service-intro-text" style={{ textAlign: 'center', fontSize: '1.4rem', fontWeight: '500', marginTop: '2rem', marginBottom: '1rem' }}>
                    {t('qtcharts.subtitle')}
                </p>

                <section className="service-section">
                    <p className="service-intro-text">
                        {t('qtcharts.intro')}
                    </p>
                </section>

                <section className="service-section">
                    <h2>{t('qtcharts.solutions_title')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h3>{t('qtcharts.prebuilt_title')}</h3>
                            <p>{t('qtcharts.prebuilt_desc')}</p>
                            <ul>
                                <li>{t('qtcharts.prebuilt_li1')}</li>
                                <li>{t('qtcharts.prebuilt_li2')}</li>
                                <li>{t('qtcharts.prebuilt_li3')}</li>
                                <li>{t('qtcharts.prebuilt_li4')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h3>{t('qtcharts.realtime_title')}</h3>
                            <p>{t('qtcharts.realtime_desc')}</p>
                            <ul>
                                <li>{t('qtcharts.realtime_li1')}</li>
                                <li>{t('qtcharts.realtime_li2')}</li>
                                <li>{t('qtcharts.realtime_li3')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h3>{t('qtcharts.custom_title')}</h3>
                            <p>{t('qtcharts.custom_desc')}</p>
                            <ul>
                                <li>{t('qtcharts.custom_li1')}</li>
                                <li>{t('qtcharts.custom_li2')}</li>
                                <li>{t('qtcharts.custom_li3')}</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('qtcharts.tech_title')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h4>{t('qtcharts.tech_charts_title')}</h4>
                            <p>{t('qtcharts.tech_charts_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('qtcharts.tech_graphs_title')}</h4>
                            <p>{t('qtcharts.tech_graphs_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h4>{t('qtcharts.tech_custom_title')}</h4>
                            <p>{t('qtcharts.tech_custom_desc')}</p>
                        </div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('qtcharts.why_title')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h3>{t('qtcharts.why_expertise_title')}</h3>
                            <p>{t('qtcharts.why_expertise_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('qtcharts.why_reusable_title')}</h3>
                            <p>{t('qtcharts.why_reusable_desc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('qtcharts.why_performance_title')}</h3>
                            <p>{t('qtcharts.why_performance_desc')}</p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default QtChartsGraphs;
